<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12" lg="12" sm="12">
        <v-row>
          <v-col
            :class="!$vuetify.breakpoint.smAndUp ? 'pb-1' : ''"
            cols="12"
            md="6"
            lg="6"
            sm="6"
          >
            <v-subheader class="display-1 font-weight-bold"
              >AMS Dashboard</v-subheader
            >
          </v-col>
          <v-col
            v-if="$vuetify.breakpoint.smAndUp"
            cols="12"
            md="6"
            lg="6"
            sm="6"
            :class="!$vuetify.breakpoint.smAndUp ? 'py-1' : ''"
          >
            <v-card-actions
              class="d-flex"
              :class="
                $vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center'
              "
            >
              <v-btn
                small
                class="mb-2"
                elevation="1"
                :to="{
                  name: 'amsCenterAllocation',
                  params: { selectedZoneId: zoneID }
                }"
                color="accent"
              >
                AMS CENTER ALLOCATION <v-icon left>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                v-if="isAMWrite"
                small
                class="mb-2"
                elevation="1"
                :to="{ name: 'AMAllocation' }"
                color="accent"
              >
                <v-icon left>mdi-plus</v-icon> AMS ALLOCATION
              </v-btn>
              <v-btn
                v-if="isZMWrite"
                small
                class="mb-2"
                elevation="1"
                :to="{ name: 'ZMAllocation' }"
                color="accent"
              >
                <v-icon left>mdi-plus</v-icon>ZM ALLOCATION
              </v-btn>
            </v-card-actions>
          </v-col>
          <v-col v-else cols="12" md="12" lg="12" xs="12">
            <v-row no-gutters>
              <v-col cols="12" md="12" lg="12" xs="12">
                <v-btn
                  small
                  class="mb-2"
                  elevation="1"
                  :to="{
                    name: 'amsCenterAllocation',
                    params: { selectedZoneId: zoneID }
                  }"
                  color="accent"
                  min-width="100%"
                >
                  AMS CENTER ALLOCATION <v-icon left>mdi-chevron-right</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="12" lg="12" xs="12">
                <v-btn
                  v-if="isAMWrite"
                  small
                  class="mb-2"
                  elevation="1"
                  :to="{ name: 'AMAllocation' }"
                  color="accent"
                  min-width="100%"
                >
                  <v-icon left>mdi-plus</v-icon> AMS ALLOCATION
                </v-btn>
              </v-col>
              <v-col cols="12" md="12" lg="12" xs="12">
                <v-btn
                  v-if="isZMWrite"
                  small
                  class="mb-2"
                  elevation="1"
                  :to="{ name: 'ZMAllocation' }"
                  color="accent"
                  min-width="100%"
                >
                  <v-icon left>mdi-plus</v-icon>ZM ALLOCATION
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12" lg="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="3"
            lg="3"
            sm="3"
            :class="!$vuetify.breakpoint.smAndUp ? 'py-1' : ''"
            v-for="(zone, index) in zoneDetails"
            :key="zone.region + '_' + index"
          >
            <v-card
              :to="{
                name: 'amsCenterAllocation',
                params: { selectedZoneId: zone.zoneID }
              }"
              elevation="4"
              class="mx-2"
            >
              <v-card-text>
                <v-row no-gutters>
                  <v-col cols="12" md="12" lg="12" sm="12">
                    <div class="mt-0" style="height: auto; overflow: hidden">
                      <span
                        class="subtitle-1 font-weight-bold text-uppercase float-left"
                        >{{ zone.region }}</span
                      >
                      <div class="center-level px-2 text-center">
                        <div class="deep-purple--text text--accent-4">
                          <v-icon color="white" small>mdi-school</v-icon>
                          <span
                            class="white--text subtitle-1 font-weight-bold pt-1"
                          >
                            {{ zone.zoneFranchiseeCount }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="mt-3" cols="12" md="6" lg="6" sm="6">
                    <v-item-group
                      class="d-flex"
                      :class="
                        !$vuetify.breakpoint.smAndUp
                          ? 'justify-space-between'
                          : 'justify-left'
                      "
                    >
                      <v-item v-if="zone.H">
                        <template v-slot:default>
                          <div class="text-center mr-1">
                            <div class="text-caption font-weight-bold">
                              {{ zone.H.priority }}
                            </div>
                            <v-avatar color="red darken-3" size="35">
                              <span
                                class="white--text font-weight-medium subtitle-1"
                                >{{ zone.H.priorityWiseFranchiseeCount }}</span
                              >
                            </v-avatar>
                          </div>
                        </template>
                      </v-item>
                      <v-item v-if="zone.M">
                        <template v-slot:default>
                          <div class="text-center mr-1">
                            <div class="text-caption font-weight-bold">
                              {{ zone.M.priority }}
                            </div>
                            <v-avatar color="orange darken-3" size="35">
                              <span
                                class="white--text font-weight-medium subtitle-1"
                                >{{ zone.M.priorityWiseFranchiseeCount }}</span
                              >
                            </v-avatar>
                          </div>
                        </template>
                      </v-item>
                      <v-item v-if="zone.L">
                        <template v-slot:default>
                          <div class="text-center">
                            <div class="text-caption font-weight-bold">
                              {{ zone.L.priority }}
                            </div>
                            <v-avatar color="green darken-3" size="35">
                              <span
                                class="white--text font-weight-medium subtitle-1"
                                >{{ zone.L.priorityWiseFranchiseeCount }}</span
                              >
                            </v-avatar>
                          </div>
                        </template>
                      </v-item>
                    </v-item-group>
                  </v-col>
                  <v-col class="mt-3" cols="12" md="6" lg="6" sm="6">
                    <p
                      class="custom-chip unallocated-border mb-1"
                      :class="!$vuetify.breakpoint.smAndUp ? 'pl-2' : 'pl-1'"
                    >
                      <span
                        class="text-caption float-left mt-2 font-weight-bold"
                        >Unallocated:
                      </span>
                      <span
                        class="custom-avatar float-right mr-1 font-weight-medium subtitle-1 red darken-3"
                        >{{
                          zone.zoneUnallocatedFranchiseeCount
                            ? zone.zoneUnallocatedFranchiseeCount
                            : 0
                        }}</span
                      >
                    </p>
                    <p
                      class="custom-chip allocated-border mb-1"
                      :class="!$vuetify.breakpoint.smAndUp ? 'pl-2' : 'pl-1'"
                    >
                      <span
                        class="text-caption float-left mt-2 font-weight-bold"
                        >Allocated:
                      </span>
                      <span
                        class="custom-avatar float-right mr-1 font-weight-medium subtitle-1 green darken-3"
                        >{{
                          zone.zoneAllocatedFranchiseeCount
                            ? zone.zoneAllocatedFranchiseeCount
                            : 0
                        }}</span
                      >
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="12"
        lg="12"
        sm="12"
        v-for="(zone, i) in zoneArray"
        :key="i"
      >
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-card elevation="4" class="mx-2" rounded>
              <v-card class="d-flex justify-space-between pa-2" elevation="0">
                <router-link
                  :to="{
                    name: 'amsCenterAllocation',
                    params: { selectedZoneId: zone.zoneID }
                  }"
                >
                  <span class="subtitle-2">{{ zone.text }}</span>
                </router-link>
                <span class="subtitle-2">{{ zone.totalCenter }}</span>
                <span class="subtitle-2">{{ zone.zonalManager }}</span>
              </v-card>
              <v-divider class="my-1"></v-divider>
              <v-card class="pa-2" elevation="0">
                <v-data-table
                  class="ams-datatable"
                  :class="$vuetify.breakpoint.smAndUp ? 'sticky-column' : ''"
                  :headers="zone.header"
                  :items="zone.dataTable"
                  hide-default-footer
                  disable-pagination
                />
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Utils from '@/utils'
import constants from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'AmsDashboard',
  data () {
    return {
      zoneDetails: [],
      zoneID: null,
      isLoading: false,
      zonePanel: 0,
      zoneArray: []
    }
  },
  computed: {
    isZMWrite: function () {
      return this.checkModuleAccess('ZMAllocation')
    },
    isAMWrite: function () {
      return this.checkModuleAccess('AMAllocation')
    }
  },
  mounted: async function () {
    this.$dialog.message.info('AMS Dashboard', {
      position: 'bottom-right',
      color: 'secondary',
      timeout: 4000
    })
  },
  created: async function () {
    await this.getZonePriorityCenter()
    await this.getZoneAcademicMangerDetails()
  },
  methods: {
    // Latest Code for AMS Dashboard
    handleExpension: function (zoneObj, i) {
      this.zoneArray.forEach((item, index) => {
        if (index !== i) {
          item.isOpen = false
        }
      })
      this.zoneArray[i].isOpen = !zoneObj.isOpen
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getZonePriorityCenter: async function () {
      try {
        const res = await http.get(
          `${constants.API_URL}/api/get/zones-priority-centers`
        )
        if (res.status === 200) {
          this.zoneDetails = _.orderBy(res.data.zoneDetails, 'zoneID', 'asc')
          this.zoneID = this.zoneDetails[0].zoneID
        } else {
          this.$dialog.message.error(res.data.message, {
            position: 'top-center',
            color: 'error',
            timeout: 4000
          })
        }
      } catch (e) {
        const errorMsg = e.response.data.message
        this.$dialog.message.error(errorMsg, {
          position: 'top-center',
          color: 'error',
          timeout: 4000
        })
      }
    },
    getZoneAcademicMangerDetails: async function () {
      try {
        this.zoneArray = []
        const res = await http.get(
          `${constants.API_URL}/api/get/zones-academic-manager-details`
        )
        if (res.status === 200) {
          res.data.zone.forEach((item, itemIndex) => {
            let headers = []
            let data = []
            if (item.academicManagers.length > 0) {
              headers.push({
                text: 'Priority',
                fixed: true,
                width: '150',
                value: 'priority',
                align: 'start',
                sortable: false
              })
              let highObj = {}
              let mediumObj = {}
              let lowObj = {}
              let totalObj = {}
              let totalHigh = 0
              let totalMedium = 0
              let totalLow = 0
              item.academicManagers.forEach((am, index) => {
                headers.push({
                  text: am.amName,
                  width: '150',
                  value: 'am' + (index + 1),
                  align: 'start',
                  sortable: false
                })
              })
              item.academicManagers.forEach((am, Amindex) => {
                // High Priority Calculation
                totalHigh += am.high.length
                highObj['am' + (Amindex + 1)] = am.high.length
                // Medium Priority Calculation
                totalMedium += am.medium.length
                mediumObj['am' + (Amindex + 1)] = am.medium.length
                // Low Priority Calculation
                totalLow += am.low.length
                lowObj['am' + (Amindex + 1)] = am.low.length

                // Priority Key Setup
                lowObj['type'] = 'Low'
                lowObj['priority'] =
                  'Low: ' + totalLow + '/' + item.lowPriorityFranchisee
                mediumObj['type'] = 'Medium'
                mediumObj['priority'] =
                  'Medium: ' + totalMedium + '/' + item.mediumPriorityFranchisee
                highObj['type'] = 'High'
                highObj['priority'] =
                  'High: ' + totalHigh + '/' + item.highPriorityFranchisee
                totalObj['priority'] =
                  'Total: ' +
                  (totalHigh + totalMedium + totalLow) +
                  '/' +
                  (item.highPriorityFranchisee +
                    item.mediumPriorityFranchisee +
                    item.lowPriorityFranchisee)
              })
              data.push(highObj)
              data.push(mediumObj)
              data.push(lowObj)
              let dataObjKeys = Object.keys(data[0])
              dataObjKeys.forEach((item) => {
                if (item !== 'priority') {
                  totalObj[item] = 0
                  data.forEach((dataItem) => {
                    totalObj[item] += dataItem[item]
                  })
                }
              })
              totalObj['type'] = 'Total'
              data.push(totalObj)
            }
            this.zoneArray.push({
              text: item.region + ' Zone',
              zoneID: item.zoneID,
              totalCenter:
                'Total Centers ' +
                item.totalZoneAllocatedFranchisees +
                '/' +
                item.totalZoneFranchisees,
              isOpen: itemIndex === 0,
              zonalManager: item.zonalManagerName,
              header: headers,
              dataTable: data
            })
          })
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMsg = e.response.data.message
        this.errMsg(errorMsg)
      }
    },
    errMsg (msg) {
      return this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: 'error',
        timeout: 4000
      })
    }
  }
}
</script>
<style>
.center-level {
  position: absolute;
  height: 30px;
  width: auto;
  top: 16px;
  right: 0px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  background: #6200ea;
}
.custom-chip {
  width: 100%;
  height: 40px;
  overflow: hidden;
  border-radius: 18px;
  justify-content: left;
  vertical-align: middle;
  padding-top: 2px;
}
.unallocated-border {
  height: 42px;
  border-radius: 19px;
  padding: 1px 0px 2px 0px;
  border: solid 2px #ef9a9a;
}
.allocated-border {
  height: 42px;
  border-radius: 19px;
  padding: 1px 0px 2px 0px;
  border: solid 2px #89a82b;
}
.custom-avatar {
  height: 35px;
  width: 35px;
  justify-content: center;
  vertical-align: middle;
  overflow: hidden;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  color: #fff;
}
.ams-datatable > div > table > tbody > tr:last-child > td {
  font-weight: bold !important;
}
.sticky-column > div > table > tbody > tr > td:nth-child(1),
.sticky-column > div > table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  left: 0;
  background: #fff;
}
.sticky-column > div > table > thead > tr > th:nth-child(1) {
  background: #5d58ef;
}
</style>
